import React, { useEffect, useState } from "react";

import CustomTable from "../../../../components/main_comps/custom_table";
import { setHeaders } from "../../../../../services/aclValidateServiceTable";
import { VanTransactionHeaders } from "../../../../../utility/TableHeaders";
import MainComponent from "../../../../components/ui_comps/MainComponent";
import { showHideFilterModalReducer } from "../../../../../data/redux/slice/globalFiltersSlice";
import { useDispatch, useSelector } from "react-redux";

import {
  CLIENT,
  TRANSACTION_CREDITED,
  TRANSACTION_FAILED,
  TRANSACTION_PENDING,
  TRANSACTION_REJECTED,
  TRANSACTION_RETURNED,
  TRANSACTION_REVERSED,
  VAN_TRANSACTION_DOWNLOAD,
  VAN_TRANSACTION_LIST
} from "../../../../../utility/constants/valueConstants";
import { fetchVanTransaction } from "../../../../../services/fetchListingData";
import ResizeListner from "../../../../../utility/ResizeListner";
import moment from "moment";
import { CustomViewModal } from "../../../../components/main_comps/custom_modal/CustomViewModal";
import CustomModal from "../../../../components/main_comps/custom_modal";
import CustomTabs from "../../../../components/main_comps/custom_tabs";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import DownloadReportTransaction from "./DownloadReportTransaction";
import {
  SS_ROLE,
  SS_USER_HASH_ID
} from "../../../../../utility/constants/secureStorageManager";
import secureStorage from "../../../../../services/secureStorage";
import CustomSelect from "../../../../components/main_comps/custom_select";
export const ActionComponent = ({
  onClick,
  aclData,
  onServiceProviderChange,
  clientSecret,
  isClient
}) => {
  const [currentSvcProvider, setCurrentSvcProvider] = useState();
  const [options, setOptions] = useState([]);
  const serviceProviders = [
    {
      label: "Equitas Van",
      value: "van"
    },
    {
      label: "Van Upi",
      value: "van-upi"
    }
  ];

  let hasVan;
  let hasVanUpi;

  //if client
  useEffect(() => {
    if (isClient) {
      hasVan = clientSecret.some(
        (obj) =>
          obj.serviceType?.toUpperCase() === "VAN" &&
          obj.serviceProviderName?.toUpperCase() === "EQUITAS"
      );

      hasVanUpi = clientSecret.some(
        (obj) =>
          obj.serviceType?.toUpperCase() === "VAN-UPI" &&
          obj.serviceProviderName?.toUpperCase() === "EQUITAS"
      );

      if (hasVan && hasVanUpi) {
        setCurrentSvcProvider({
          label: "Equitas Van",
          value: "van"
        });
        setOptions(serviceProviders);
      } else if (hasVan) {
        setCurrentSvcProvider({
          label: "Equitas Van",
          value: "van"
        });
        setOptions([
          {
            label: "Equitas Van",
            value: "van"
          }
        ]);
      } else if (hasVanUpi) {
        setCurrentSvcProvider({
          label: "Van Upi",
          value: "van-upi"
        });
        setOptions([
          {
            label: "Van Upi",
            value: "van-upi"
          }
        ]);
      }
    }
  }, [isClient, clientSecret]);

  //not client
  useEffect(() => {
    if (!isClient) {
      setCurrentSvcProvider({
        label: "Equitas Van",
        value: "van"
      });
      setOptions(serviceProviders);
    }
  }, [isClient]);
  useEffect(() => {
    onServiceProviderChange(currentSvcProvider);
  }, [currentSvcProvider]);
  return (
    <div style={{ display: "flex" }}>
      <CustomSelect
        options={options}
        isSearchable={false}
        onChange={(data) => {
          setCurrentSvcProvider(data);
        }}
        value={currentSvcProvider}
        style={{
          height: 40,
          backgroundColor: "rgba(111, 108, 255, 0.1)",
          border: "1px solid #001777",
          "&:hover": {
            border: "1px solid #001777"
          },
          borderRadius: "4px"
        }}
      />
      {aclData?.includes(VAN_TRANSACTION_DOWNLOAD) && (
        <CustomButton
          styles={{
            backgroundColor: "#38369C",
            border: "1px solid #38369C",
            marginLeft: "10px"
          }}
          title="Download Report"
          textStyles={{ color: "white" }}
          onClick={onClick}
        />
      )}
    </div>
  );
};
const VanTransactionIndex = ({ onChange }) => {
  const role = secureStorage.getItem(SS_ROLE);

  const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
  // const { width, height } = ResizeListner();
  const dispatch = useDispatch();
  const vanList = useSelector((state) => state.listingSlice?.vanDetails);
  const [viewMoreData, setViewMoreData] = useState({});
  useEffect(() => {
    setViewMoreData(vanList?.transactions || []);
  }, []);

  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);

  // const [transactionList, setTransactionList] = useState([]);
  // const [totalElements, setTotalElements] = useState(100);
  // const [page, setPage] = useState(0);
  // const [onClickViewMore, setOnClickViewMore] = useState("");
  const [viewMoreModal, setViewMoreModal] = useState(false);
  const [dataForModal, setDataForModal] = useState({});
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const filters = useSelector((state) => state.globalFiltersSlice);
  const [clientDetails, setClientDetials] = useState({});
  const aclData = useSelector((state) => state.aclSlice.aclList);
  const [serviceProviderType, setServiceProviderType] = useState("");
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    fontWeight: "400",
    fontSize: "14px",
    color: "#6C6B6B"
  };
  const containerStyle = {
    height: "20px",
    width: "300px",
    border: "none"
  };

  const getClientProgram = () => {
    let van = clientSecret.filter(
      (obj) =>
        obj.serviceType?.toUpperCase() === "VAN" &&
        obj.serviceProviderName?.toUpperCase() === "EQUITAS"
    );
    if (van.length > 0) {
      setClientDetials(van[0]);
    }
    let vanUpi = clientSecret.filter(
      (obj) =>
        obj.serviceType?.toUpperCase() === "VAN-UPI" &&
        obj.serviceProviderName?.toUpperCase() === "EQUITAS"
    );
    if (vanUpi.length > 0) {
      setClientDetials(vanUpi[0]);
    }
  };

  const options = [
    {
      label: "Action needed",
      value: ""
    },
    {
      label: "Approve",
      value: "approve"
    },
    {
      label: "Reject",
      value: "reject"
    }
  ];
  useEffect(() => {
    let data = {
      "transfer_timestamp:": moment(viewMoreData?.transferTimestamp).format(
        "DD/MM/YYYY HH:mm A" || "N/A"
      ),
      "Bank UTR": viewMoreData?.bankUtr || "N/A",
      "NK UTR": viewMoreData?.transferUniqueNo || "N/A",
      "Transaction Type": viewMoreData?.transfer_type || "N/A",
      Transfer_amt: viewMoreData?.actual_amount || "N/A",

      rmtr_account_no: viewMoreData?.rmtr_account_no || "N/A",
      rmtr_account_ifsc: viewMoreData?.rmtr_account_ifsc || "N/A",
      rmtr_account_type: viewMoreData?.rmtr_account_type || "N/A",
      rmtr_full_name: viewMoreData?.rmtr_full_name || "N/A",
      rmtr_to_bene_note: viewMoreData?.rmtrToBeneNote || "N/A",
      reference_id: viewMoreData?.transferUniqueNo || "N/A",
      attempt_no: viewMoreData?.attemptNo || "N/A",
      rmtr_address: viewMoreData?.rmtrAddress || "N/A",
      Status:
        viewMoreData?.status === "SUCCESS" ||
        viewMoreData?.status === "CREDITED"
          ? "Success"
          : viewMoreData?.status === "FAILED"
          ? "Failed"
          : viewMoreData?.status === TRANSACTION_PENDING
          ? "Initiated"
          : viewMoreData?.status === TRANSACTION_REJECTED
          ? "Rejected"
          : viewMoreData?.status === TRANSACTION_PENDING
          ? "Pending"
          : viewMoreData?.status === TRANSACTION_REVERSED
          ? "Reversed"
          : viewMoreData?.status === TRANSACTION_RETURNED
          ? "Returned"
          : "" || "N/A",
      "Credited time":
        moment(viewMoreData?.created_at).format("DD/MM/YYYY HH:mm A") || "N/A"
    };
    if (serviceProviderType === "van") {
      data.VAN = viewMoreData?.bene_account_no || "N/A";
      data.Bene_account_ifsc = viewMoreData?.bene_account_ifsc || "N/A";
      data.creditaccountnumber = viewMoreData?.creditaccountnumber;
    }
    if (serviceProviderType === "van-upi") {
      console.log(viewMoreData, "view data");
      data.Van_Upi_Id = viewMoreData?.van_upi_id || "N/A";
      data.creditAccountNumber = viewMoreData.creditAccountNumber || "N/A";
    }
    setDataForModal({ ...data });
  }, [viewMoreData]);

  useEffect(() => {
    if (serviceProviderType) {
      dispatch(
        fetchVanTransaction({
          page: 0,
          size: 10,
          totalRecords: "",
          dateRange: "",
          business: "",
          keyWord: "",
          van: "",
          name: "",
          status: "",
          clientHashId: role === CLIENT ? ss_id : "",
          txnId: "",
          transferType: "",
          utr: "",
          programId: role === CLIENT ? clientDetails?.program : "",
          serviceType: serviceProviderType
        })
      );
    }
  }, [serviceProviderType]);

  useEffect(() => {
    if (role === CLIENT) {
      getClientProgram();
    }
  }, []);
  const setHeaders = (data, role, serviceProviderType, acl) => {
    let arr = [];
    let updatedData = data.filter(
      (e) =>
        e.serviceProviderType === serviceProviderType ||
        e.serviceProviderType === "all"
    );

    updatedData &&
      updatedData?.map((val, i) => {
        if (val?.roles || val?.acl) {
          if (val?.roles?.includes(role) || acl?.includes(val?.acl))
            arr.push({
              title: val?.title,
              key: val?.key
            });
        } else {
          arr.push({
            title: val?.title,
            key: val?.key
          });
        }
      });
    return arr;
  };

  return (
    <div
      style={{
        marginLeft: "20px",
        overflow: "auto",
        boxSizing: "border-box",
        width: "100%"
      }}
    >
      <MainComponent
        currentServiceType={serviceProviderType}
        headerTitle="Transaction"
        notificationRequired={false}
        filterRequired={true}
        onClickFilter={() => {
          dispatch(
            showHideFilterModalReducer({
              showFilterModal: true,
              filters: [
                "dateRange",
                "clientName",
                "vanNumber",
                "bankUTR",
                "VanTransactionStatusOptions"
              ]
            })
          );
        }}
        onClickFilterCall={(data) => {
          // setPage(0);
          dispatch(
            fetchVanTransaction({
              page: 0,
              size: 10,
              totalRecords: "",
              dateRange:
                data?.fromDate && data?.toDate
                  ? moment(data?.fromDate).format("DD/MM/YYYY") +
                    "-" +
                    moment(data?.toDate).format("DD/MM/YYYY")
                  : "",
              business: "",
              keyWord: "",
              van: data?.van ?? "",
              name: "",
              status: data?.status?.value ?? "",
              clientHashId:
                role === CLIENT ? ss_id : data?.clientId?.value ?? "",
              txnId: "",
              transferType: "",
              utr: data?.bankUTR ?? "",
              programId: role === CLIENT ? clientDetails?.program : "",
              serviceType: serviceProviderType
            })
          );
        }}
      />
      <CustomTabs
        actionComponent={
          <ActionComponent
            onClick={() => setShowDownloadModal(true)}
            aclData={aclData}
            onServiceProviderChange={(data) => {
              setServiceProviderType(data?.value);
            }}
            clientSecret={clientSecret}
            isClient={role === CLIENT}
          />
        }
      />
      {showDownloadModal && (
        <CustomModal
          headerTitle="Download Report"
          open={showDownloadModal}
          onClose={() => {
            setShowDownloadModal(false);
          }}
          containerStyle={styles.modalContainerStyle}
        >
          <DownloadReportTransaction
            programId={clientDetails?.program}
            serviceProviderType={serviceProviderType}
            onClose={() => {
              setShowDownloadModal(false);
            }}
          />
        </CustomModal>
      )}

      {/* <div style={styles.upperdiv}>
          <div>
            <Refreshopt style={styles.image} />
            <Filteropt
              style={styles.image}
              onClick={() => {
                setFilter(!filter);
              }}
            />
            <Downloadopt style={styles.image} />
          </div>

          <div style={styles.searchdiv}>
            <Searchopt style={styles.image} />
            <CustomInput
              placeholder="Search by client name, email..."
              inputcomponentStyles={{ ...inputStyle }}
              inputStyles={{
                ...containerStyle,
              }}
            />
          </div>
        </div>
        {filter && (
          <>
            <FilterComponent
              filters={[
                { name: "searching", type: "searchAction" },
                { name: "date", type: "dateRange" },
                { name: "Client", type: "search" },
                { name: "VAN", type: "search" },
                { name: "Business", type: "search" },
                { name: "Status", type: "search" },
              ]}
            />
          </>
        )} */}
      <div style={styles.maindiv}>
        <div style={styles.tablestyle}>
          {aclData?.includes(VAN_TRANSACTION_LIST) && (
            <CustomTable
              data={vanList?.transactions}
              currentPage={vanList?.currentPageNo - 1}
              headers={setHeaders(
                VanTransactionHeaders,
                role,
                serviceProviderType
              )}
              totalElements={vanList?.totalRecords}
              totalPages={vanList?.totalPages}
              handlePaginate={(page) => {
                if (serviceProviderType) {
                  dispatch(
                    fetchVanTransaction({
                      page: page + 1,
                      size: 10,
                      dateRange:
                        filters?.fromDate && filters?.toDate
                          ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                            "-" +
                            moment(filters?.toDate).format("DD/MM/YYYY")
                          : "",
                      business: "",
                      keyWord: "",
                      van: filters?.van ?? "",
                      name: "",
                      status: filters?.status?.value ?? "",
                      clientHashId:
                        role === CLIENT
                          ? ss_id
                          : filters?.clientId?.value ?? "",

                      txnId: "",
                      transferType: "",
                      utr: filters?.bankUTR ?? "",
                      programId: role === CLIENT ? clientDetails?.program : "",
                      serviceType: serviceProviderType
                    })
                  );
                }
              }}
              onViewMore={(row) => {
                setViewMoreModal(true);
                setViewMoreData(row);
              }}
            />
          )}

          {viewMoreModal && (
            <CustomModal
              open={viewMoreModal}
              onClose={() => {
                setViewMoreModal(false);
                // setDataForModal({});
              }}
              containerStyle={{
                minWidth: 350,
                maxWidth: 450,
                height: "100%",
                borderRadius: "20px 0px 0px 20px"
              }}
              viewMoreStyle={{
                justifyContent: "flex-end"
              }}
              isHeaderRequired={false}
            >
              <CustomViewModal
                data={dataForModal}
                closeModal={() => {
                  setViewMoreModal(false);
                  setDataForModal({});
                }}
              />
            </CustomModal>
          )}
        </div>
      </div>
    </div>
  );
};
const styles = {
  upperdiv: {
    height: "52px",
    background: "#F7F9FB",
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    //paddingTop: "5px",
    paddingRight: "20px",
    //border: "1px solid red",
    marginBottom: "20px"
  },
  image: {
    height: "20px",
    width: "20px",
    margin: "10px"
  },
  image2: {
    height: "20px",
    width: "20px"
  },
  searchdiv: {
    width: "360px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    background: "#FFFFFF",
    border: "1px solid rgba(105, 105, 105, 0.3)",
    borderRadius: "6px"
  },
  maindiv: {
    backgroundColor: "#FFFFFF",
    paddingTop: "20px",
    paddingLeft: "20px"
  },
  tablestyle: {
    overflow: "hidden"
  },
  modalContainerStyle: {
    minWidth: 350,
    maxWidth: 450,
    height: "auto",
    maxHeight: 800
  }
};
export default VanTransactionIndex;
